var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHumid = function SvgHumid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.3 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.01 4.76C9.09 3.64 6.24.62 6.12.5L5.65 0l-.47.5c-.12.13-2.97 3.15-3.89 4.26A5.662 5.662 0 0 0 0 8.35C0 11.46 2.53 14 5.65 14s5.65-2.53 5.65-5.65c0-1.31-.46-2.58-1.29-3.59ZM5.65 12.7c-2.4 0-4.35-1.95-4.35-4.35 0-1.01.35-1.99.99-2.76.67-.82 2.49-2.77 3.36-3.7.87.92 2.69 2.88 3.36 3.7.64.78.99 1.76.99 2.76 0 2.4-1.95 4.35-4.35 4.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49 8.3h-1.3c0 1.9 1.55 3.45 3.45 3.45v-1.3c-1.19 0-2.15-.97-2.15-2.15Z"
  })));
};

export default SvgHumid;